import { render, staticRenderFns } from "./workFlows.vue?vue&type=template&id=b485ed38&scoped=true"
import script from "./workFlows.vue?vue&type=script&lang=js"
export * from "./workFlows.vue?vue&type=script&lang=js"
import style0 from "./workFlows.vue?vue&type=style&index=0&id=b485ed38&prod&scoped=true&lang=css"
import style1 from "./workFlows.vue?vue&type=style&index=1&id=b485ed38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b485ed38",
  null
  
)

export default component.exports